var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.524,
    x2: 444.685,
    y1: 456.355,
    y2: 41.432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2deff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6852,
    stopColor: "#d2deff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.896 326.915c17.448 172.872 292.417 167.142 420.804 136.265 82.47-19.834 87.596-59.472 86.106-144.001-.96-54.486 3.443-198.725-32.004-244.123-54.448-69.733-103.228-25.998-170.656-3.235-86.488 29.197-120.189-22.932-202.476-21.38-120.641 2.278-110.779 187.252-101.774 276.474z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.47 454.789h-398.94c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15-15 15z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 430.789h-398.94c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15-15 15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 430.786h259.47c8.284 0 15-6.716 15-15v-42.856h-274.47z",
    fill: "#d2deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 430.789h-139.47c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h139.47z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 110.485,
    cy: 215.71,
    fill: "#02ffb3",
    r: 33.651
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.625 228.464c-2.93 3-4.75 7.1-4.75 11.61v4.91c3.07 1.74 6.43 3.02 10 3.73v-8.64c0-3.64 2.96-6.61 6.61-6.61s6.61 2.97 6.61 6.61v8.64c3.57-.71 6.94-1.99 10-3.73v-4.91c0-4.51-1.81-8.61-4.75-11.61 2.94-3 4.75-7.1 4.75-11.61 0-9.16-7.45-16.62-16.61-16.62s-16.61 7.46-16.61 16.62c0 4.51 1.82 8.61 4.75 11.61zm5.25-11.61c0-3.65 2.96-6.62 6.61-6.62s6.61 2.97 6.61 6.62c0 3.64-2.96 6.61-6.61 6.61s-6.61-2.97-6.61-6.61z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.014 267.825h-83.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h83.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#4369fd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m144.014 288.313h-62.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h62.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#4369fd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m144.014 308.801h-62.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h62.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#4369fd"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m165.014 345.934h-83.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h83.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.014 366.421h-83.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h83.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.014 386.909h-83.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h83.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m275.004 386.909h-41.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h41.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.85 386.909h-41.18c-2.761 0-5 2.239-5 5s2.239 5 5 5h41.181c2.761 0 5-2.239 5-5s-2.239-5-5.001-5z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.697 386.909h-41.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h41.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#00d890"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 165.012,
    cy: 187.061,
    fill: "#fff",
    r: 5.002
  })), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 155.836v-54.313c0-8.284-6.716-15-15-15h-398.94c-8.284 0-15 6.716-15 15v54.313z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.471 435.789h-398.941c-11.028 0-20-8.972-20-20v-314.266c0-11.028 8.972-20 20-20h398.941c11.028 0 20 8.972 20 20v314.266c0 11.028-8.972 20-20 20zm-398.941-344.266c-5.514 0-10 4.486-10 10v314.266c0 5.514 4.486 10 10 10h398.941c5.514 0 10-4.486 10-10v-314.266c0-5.514-4.486-10-10-10z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.623,
    cy: 123.424,
    fill: "#ff5ba8",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.424,
    cy: 123.424,
    fill: "#fff",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.224,
    cy: 123.424,
    fill: "#02ffb3",
    r: 10.901
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.277 135.672h-136.158v-24.496h136.159c2.761 0 5 2.239 5 5v14.496c-.001 2.761-2.239 5-5.001 5z",
    fill: "#ffdbed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.789 111.488c-5.286-5.286-13.887-5.286-19.173 0s-5.286 13.887 0 19.173c4.037 4.037 10.003 4.98 14.953 2.852l4.348 4.348c1.952 1.952 5.119 1.952 7.071 0s1.952-5.119 0-7.071l-4.348-4.348c2.129-4.951 1.186-10.918-2.851-14.954zm-12.102 7.071c1.387-1.387 3.644-1.387 5.031 0s1.387 3.644 0 5.031-3.644 1.387-5.031 0c-1.387-1.388-1.387-3.644 0-5.031z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.455 372.93h-34.632v-84.084c0-2.761 2.239-5 5-5h24.632c2.761 0 5 2.239 5 5z",
    fill: "#02ffb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.435 372.93h-34.632v-144.084c0-2.761 2.239-5 5-5h24.632c2.761 0 5 2.239 5 5z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.415 372.93h-34.632v-174.084c0-2.761 2.239-5 5-5h24.632c2.761 0 5 2.239 5 5z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.395 372.93h-34.632v-144.084c0-2.761 2.239-5 5-5h24.632c2.761 0 5 2.239 5 5z",
    fill: "#ff7eb8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m336.526 48.171c-7.88 0-14.291-6.411-14.291-14.292 0-7.88 6.411-14.291 14.291-14.291 7.881 0 14.292 6.411 14.292 14.291 0 7.881-6.411 14.292-14.292 14.292zm0-18.583c-2.366 0-4.291 1.925-4.291 4.291s1.925 4.292 4.291 4.292 4.292-1.926 4.292-4.292-1.925-4.291-4.292-4.291z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.523 492.412c-7.88 0-14.292-6.411-14.292-14.292 0-7.88 6.411-14.291 14.292-14.291s14.292 6.411 14.292 14.291c-.001 7.881-6.412 14.292-14.292 14.292zm0-18.583c-2.366 0-4.292 1.925-4.292 4.291s1.925 4.292 4.292 4.292 4.292-1.926 4.292-4.292-1.926-4.291-4.292-4.291z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.203 59.171c-7.881 0-14.292-6.411-14.292-14.292 0-7.88 6.411-14.291 14.292-14.291 7.88 0 14.291 6.411 14.291 14.291 0 7.881-6.411 14.292-14.291 14.292zm0-18.583c-2.366 0-4.292 1.925-4.292 4.291s1.926 4.292 4.292 4.292 4.291-1.926 4.291-4.292-1.925-4.291-4.291-4.291z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.235 489.703c-7.881 0-14.292-6.411-14.292-14.291 0-7.881 6.411-14.292 14.292-14.292 7.88 0 14.291 6.411 14.291 14.292 0 7.88-6.411 14.291-14.291 14.291zm0-18.583c-2.366 0-4.292 1.926-4.292 4.292s1.926 4.291 4.292 4.291 4.291-1.925 4.291-4.291-1.924-4.292-4.291-4.292z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.652 480.12c-2.762 0-5-2.238-5-5 0-3.309-2.692-6-6.001-6-2.762 0-5-2.238-5-5s2.238-5 5-5c3.309 0 6.001-2.691 6.001-6 0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.309 2.691 6 5.999 6 2.762 0 5 2.238 5 5s-2.238 5-5 5c-3.308 0-5.999 2.691-5.999 6 0 2.762-2.238 5-5 5z",
    fill: "#ff5ba8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.08d63053918d104ad61d2247822b99fe.svg";
export { ForwardRef as ReactComponent };